import { ActionBase } from "./ActionBase";

export const SIGNALR_CLIENT_ACTION = '[Application] SignalR Client Event';

export class SignalRClientAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SIGNALR_CLIENT_ACTION;

  constructor(public payload: { actionName: string, model: any }){}
}



// WEBPACK FOOTER //
// ./src/app/core/store/action/SignalRClientAction.ts